import React from 'react'

function ProductHeading() {
    return (
        <div className="container mt-3">
            <div className="text-center">
                <h1 className="choose-heading">Our Products</h1>
            </div>
        </div>
    )
}

export default ProductHeading